// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"459f76b4","171":"b93bda69","432":"14eda975","994":"4ca69fed"}[chunkId] + ".chunk.js";
};